<template>
    <v-menu left>
        <template v-slot:activator="{ on }">
                <v-btn icon
                       v-show="show"
                       color="white"
                       class="mr-n2"
                       v-on="on">
                    <v-icon>mdi-earth</v-icon>
                </v-btn>
        </template>

        <v-list class="pt-0 pb-0">
            <v-list-item v-for="(item, i) in localeSelect"
                         :key="i"
                         ripple
                         @click="setLang(item.value)">
                <v-list-item-title>{{ $vuetify.lang.t(item.text) }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>
<script>
    // 3rd
    import {
        mapActions,
        mapState,
    } from 'vuex';
    // utils
    import {
        transformArrayToSelectValues,
    } from '../utils/helper';
    import {
        LOCAL_STORAGE_LOCALE,
    } from '../utils/constants';

    export default {
        name: 'language-switch',
        props: {
            show: {
                required: true,
                type: Boolean,
            },
        },
        computed: {
            ...mapState([
                'locales',
            ]),
            localeSelect() {
                return transformArrayToSelectValues(this.locales, '$vuetify.locale.');
            },
        },
        methods: {
            ...mapActions(['fetchBootstrap']),
            setLang(lang) {
                this.$i18n.locale = lang;
                localStorage.setItem(LOCAL_STORAGE_LOCALE, lang);
                this.fetchBootstrap();
            },
        }
    }
</script>
